<livechat-widget #liveChatWidget license="{{licenseId}}" visibility="minimized"
    (onVisibilityChanged)="showHideChatWindow($event)">
</livechat-widget>